// Centralized contact & location constants — used in Hero, Footer, LocalBusiness schema.
export const CONTACT = {
  phone: "+4915772982469",
  phoneDisplay: "+49 1577 2982469",
  email: "hello@aivinity.de",
  street: "Charlottenburger Allee 61",
  postalCode: "52068",
  city: "Aachen",
  region: "Nordrhein-Westfalen",
  country: "DE",
  googleBusinessUrl:
    "https://www.google.com/search?q=aivinity+aachen",
  instagramUrl: "https://instagram.com/jcproductions.de",
  linkedinUrl: "https://www.linkedin.com/in/janclassen/",
} as const;

export const AREAS_SERVED = [
  "Aachen",
  "Köln",
  "Düsseldorf",
  "Bonn",
  "Mönchengladbach",
  "Nordrhein-Westfalen",
] as const;
